import { Translate } from 'next-translate'

import {
  CapacityConflictAdjustVerb,
  CapacityConflictOptionType,
  CapacityConflictType,
} from '../types'

export type CapacityConflictTitleContext = {
  /** null means still on the choice step (only possible when !single) */
  path: CapacityConflictOptionType | null
  /** Only one resolution option exists, so the choice step is skipped */
  single: boolean
  type: CapacityConflictType
  /** What the adjust step is really asking for - it names the step. */
  verb: CapacityConflictAdjustVerb
}

function getBaseTitle(type: CapacityConflictType, t: Translate): string {
  return type === CapacityConflictType.AllProductsBlocked
    ? t('checkoutCapacityConflict.baseTitleAllBlocked')
    : t('checkoutCapacityConflict.baseTitleSomeBlocked')
}

function getCapacityConflictTitle(
  ctx: CapacityConflictTitleContext,
  t: Translate,
): string {
  switch (ctx.path) {
    case CapacityConflictOptionType.ChangePickupTime:
      return t('checkoutCapacityConflict.timeStepTitle')
    case CapacityConflictOptionType.AdjustOrder:
      if (ctx.single) {
        return getBaseTitle(ctx.type, t)
      }

      return ctx.verb === CapacityConflictAdjustVerb.Remove
        ? t('checkoutCapacityConflict.adjustStepTitleRemoveOnly')
        : t('checkoutCapacityConflict.adjustStepTitle')
    case CapacityConflictOptionType.DeleteOrder:
      return ctx.single
        ? getBaseTitle(ctx.type, t)
        : t('checkoutCapacityConflict.deleteStepTitle')
    default:
      return getBaseTitle(ctx.type, t)
  }
}

export default getCapacityConflictTitle
